module.exports = __webpack_public_path__ + "static/img/jupyter.79fe05a0.png";